/* Manual review browsing; safe for multiple instances and Shopify section reloads. */
(() => {
  if (window.hhhEditorialReviews) {
    window.hhhEditorialReviews.init(document);
    return;
  }
  const instances = new WeakMap();
  function init(root) {
    const regions = root.matches?.('[data-customer-voices]')
      ? [root] : root.querySelectorAll('[data-customer-voices]');
    regions.forEach(region => {
      if (instances.has(region)) return;
      const slides = [...region.querySelectorAll('[data-review-slide]')];
      const stage = region.querySelector('.review-slides');
      const controls = region.querySelector('.review-controls');
      const counter = region.querySelector('[data-review-count]');
      const status = region.querySelector('[data-review-status]');
      if (!slides.length || !stage || !controls || !counter || !status) return;
      let index = 0;
      function show(next, announce = true) {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          const inactive = position !== index;
          slide.setAttribute('aria-hidden', String(inactive));
          slide.inert = inactive;
        });
        counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        if (announce) status.textContent = `Review ${index + 1} of ${slides.length}: ${slides[index].querySelector('figcaption strong')?.textContent || ''}`;
      }
      region.querySelector('[data-review-prev]')?.addEventListener('click', () => show(index - 1));
      region.querySelector('[data-review-next]')?.addEventListener('click', () => show(index + 1));
      stage.classList.add('is-enhanced');
      show(0, false);
      controls.hidden = slides.length < 2;
      instances.set(region, { slides, show });
    });
  }
  window.hhhEditorialReviews = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-review-slide]');
    const region = slide?.closest('[data-customer-voices]');
    const instance = region && instances.get(region);
    if (instance) instance.show(instance.slides.indexOf(slide));
  });
})();
